const stats = [
  {
    number: "+100",
    label: "عملية تدوير",
  },
  {
    number: "+50",
    label: "عميل",
  },
  {
    number: "10+",
    label: "سنوات خبرة",
  },
  {
    number: "24/7",
    label: "اهتمام بخدمتكم",
  },
];

export default function AboutStats() {
  return (
    <section className="bg-gray-950 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-y-10 md:grid-cols-4">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl font-bold text-green-400 md:text-4xl">
                {stat.number}
              </div>

              <div className="mt-2 text-sm text-gray-400">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
